import { hasOptions, type Comparable, type FieldTypeCard, type ValueKind } from '../field-types/card';
import { isFilled } from './required';
import { USER_PLACEHOLDERS } from '../texts/userPlaceholders';

export const repeatedRow = (
  card: FieldTypeCard,
  value: NonNullable<unknown>,
  rowsAbove: unknown[],
): number | undefined => {
  const { comparable } = card;
  if (!comparable) return undefined;
  const mine = comparable(value);
  const index = rowsAbove.findIndex(other => isFilled(card, other) && same(comparable(other), mine));
  return index < 0 ? undefined : index + 1;
};

const same = (a: Comparable, b: Comparable): boolean => {
  if (typeof a !== 'object' || typeof b !== 'object') return a === b;
  return a.length === b.length && a.every(item => b.includes(item));
};

export const uniqueText = (valueKind: ValueKind, row: number): string => {
  return USER_PLACEHOLDERS.unique(row, hasOptions(valueKind));
};
